var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEliot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    xlink: "http://www.w3.org/1999/xlink",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper",
    transform: "scale(3 3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6610",
    d: "M225 225H-25V-25h250V225z",
    fill: "#4f8e99",
    strokeWidth: "none",
    opacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-subwrapper",
    transform: "matrix(0.84999948 0 0 0.84999948 14.979303539305008 16.25169637274071) translate(0 6.0000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6188",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#080806",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2893",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#93614a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2894",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#a27662",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2895",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#844e35",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2896",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#652e15",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6468",
    d: "M117.136 169.742c2.515-1.069 5.217-3.028 7.927-5.519 -0.494-0.746-0.828-1.684-0.841-2.49 -0.093-7.296 1.775-22.369 3.054-31.753 -15.779-1.925-38.771-1.917-54.549 0.014 1.278 9.384 3.145 24.446 3.05 31.738 -0.01 0.789-0.348 1.735-0.84 2.485 2.712 2.493 5.416 4.454 7.932 5.524C90.312 172.907 109.693 172.907 117.136 169.742z",
    fill: "url(#SvgjsLinearGradient6469)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6612",
    d: "M101.688 234.395c-25.465 0-58.198-0.15-68.039-0.572 4.435-21.314 2.778-32.293-2.083-51.712 7.118-1.747 11.921-2.536 15.448-3.115 3.791-0.622 6.156-1.01 8.266-2.107 9.996 10.482 26.913 21.372 42.48 22.287 0.853 0.055 1.725 0.083 2.59 0.083 14.474-0.001 30.848-8.04 44.97-22.066 1.895 0.788 5.364 1.405 9.692 2.174 4.087 0.727 8.7 1.547 13.425 2.744 -0.146 0.631-0.348 1.411-0.585 2.329 -2.096 8.12-6.979 27.043-1.495 49.473 -8.767 0.334-38.515 0.483-64.664 0.483C101.69 234.395 101.689 234.395 101.688 234.395z",
    fill: "#f3cd12",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6613",
    d: "M168.437 182.109c-0.146 0.631-0.348 1.411-0.585 2.329 -0.04 0.155-0.083 0.322-0.125 0.486 -0.941-0.22-1.881-0.428-2.82-0.631 -3.222 8.649-3.854 17.85-5.906 27.138 0.91-9.095 2.662-18.19 5.227-27.284 -4.44-0.948-8.838-1.772-13.134-2.786 -8.754 9.71-17.364 16.523-32.093 21.21 11.967-5.532 22.172-12.342 30.639-21.558 -2.163-0.538-4.3-1.132-6.396-1.834 0.696-0.652 1.392-1.308 2.077-1.988 1.895 0.788 5.364 1.405 9.692 2.174C159.099 180.092 163.712 180.912 168.437 182.109zM51.595 180.616c1.914-0.521 3.81-1.086 5.666-1.735 -0.687-0.664-1.348-1.329-1.98-1.993 -2.11 1.098-4.475 1.485-8.266 2.107 -3.527 0.579-8.33 1.368-15.448 3.115 0.273 1.092 0.535 2.154 0.788 3.196 1.447-0.405 2.919-0.774 4.4-1.135 3.673 11.104 3.987 21.547 4.922 31.828 0.812-11.37-0.723-21.574-3.674-32.13 4.016-0.949 8.107-1.822 12.133-2.867 7.079 11.543 19.533 20.314 35.42 23.309C72.141 200.963 58.499 191.987 51.595 180.616z",
    fill: "#ffdb2c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6614",
    d: "M145.209 176.596c-12.454 12.454-29.807 23.209-47.42 22.08 -15.392-0.905-32.436-11.828-42.41-22.41 -4.033 2.277-8.788 1.604-24.42 5.479 4.935 19.644 6.746 30.475 2.08 52.55 16.636 0.813 118.965 0.757 133.95 0.091 -6.501-25.792 0.858-47.021 2.04-52.641C158.754 179.089 148.545 178.184 145.209 176.596zM53.459 178.186c0.933-0.373 1.051-0.508 1.62-0.87 15.396 17.658 35.784 28.655 57.57 22.37 13.08-3.646 23.385-12.047 32.529-22.2 1.487 0.895 4.46 1.528 5.471 1.73 -30.278 34.504-78.329 31.856-100.11-0.271C50.582 178.945 53.417 178.196 53.459 178.186zM163.129 199.735c-1.298 13.933-1.223 22.593 2.91 33.9 -44.676-0.606-84.856-0.854-132.11 0.069 1.255-3.44 2.254-6.91 2.91-10.729 2.972-21.908-2.426-33.57-4.94-40.771 0.793-0.157 3.361-0.55 3.39-0.55 3.845 8.002 7.613 37.449 3.34 49.54 0.096-0.22 0.865-2.031 0.91-2.28 0.01-0.02 0.02-0.06 0.01-0.109 -0.02-0.04-0.05-0.08-0.05-0.09 -0.105-0.115 0.32-1.77 0.36-1.921 4.014-14.127-0.24-38.177-4.09-45.22 1-0.163 11.258-1.77 14.56-2.57 3.163 4.947 3.782 5.401 6.42 8.5 8.407 9.228 21.518 15.88 30.9 17.171 24.688 3.962 45.419-4.096 62.78-24.48 0.24-0.3 0.471-0.59 0.69-0.88 2.487 0.472 1.79 0.42 13.31 2.29 -0.316 1-2.228 6.244-3.489 11 -1.95 8.286-3.622 23.485-1.511 31.27 1.513 6.478 1.03 3.788 1.03 5.07 0.069 0.229 0.841 2.093 0.91 2.25 -0.186-0.528-0.73-2.33-0.73-2.33 0.331 0-0.638-4.805-0.699-5.14 -2.313-10.642 1.77-30.923 4.96-42.05 0.205 0.031 2.867 0.453 3.2 0.52C165.977 188.26 163.35 195.114 163.129 199.735z",
    fill: "#c5a400",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z",
    fill: "#93614a",
    stroke: "#652e15",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2907",
    d: "M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2908",
    d: "M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z",
    fill: "#93614a",
    stroke: "#652e15",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2909",
    d: "M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6465",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "#93614a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6466",
    d: "M110.152 1.984c26.994 6.347 47.097 30.857 47.052 60.124 -0.009 5.407-0.704 10.65-2.004 15.646 -0.012 0.054-9.158 37.218-14.396 48.677 -4.417 9.659-16.244 27.271-25.867 31.821 -3.169 1.499-11.439 1.855-14.935 1.855 -3.494 0-11.765-0.356-14.933-1.855 -9.623-4.55-21.451-22.162-25.867-31.821 -5.239-11.459-14.385-48.623-14.396-48.677 -1.3-4.995-1.996-10.239-2.004-15.646C42.756 32.841 62.857 8.331 89.853 1.984 61.03 6.885 39.087 32.276 39.134 62.854c0.008 5.406 0.704 10.649 2.004 15.645 0.012 0.054 8.781 37.213 14.13 48.677 4.602 9.862 17.738 27.917 27.601 32.566 3.671 1.732 13.088 2.374 17.134 2.374 4.043 0 13.464-0.643 17.133-2.374 9.862-4.649 23-22.704 27.601-32.566 5.35-11.464 14.119-48.623 14.13-48.677 1.3-4.996 1.996-10.239 2.004-15.645C160.918 32.276 138.975 6.885 110.152 1.984z",
    fill: "#8b573f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6467",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "none",
    stroke: "#652e15",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(0.79999927 0 0 0.79999927 19.97397427192749 27.687001386776046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6369",
    d: "M96.227 139.237l8.297-0.207C103.563 143.5 96.884 142.858 96.227 139.237z",
    fill: "url(#SvgjsLinearGradient6370)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6373",
    d: "M96.343 139.52c-0.371-0.05-0.315-0.579 0.08-0.542 0.043 0.006 4.308 0.546 7.878-0.215 0.386-0.075 0.5 0.455 0.13 0.534C101.634 139.895 98.015 139.755 96.343 139.52zM100.083 135.95c-1.503 0-2.96-0.521-4.424-0.776 -1.64-0.287-3.274-0.041-4.915 0.104 -1.676 0.149-5.333-0.013-6.365-0.666 -0.578-0.367-0.47-1.221 0.181-1.449 0.614-0.22 1.571 0.236 2.191 0.347 2.872 0.515 4.384-0.034 6.902-0.118 3.851-0.116 4.26 1.501 9.064 0.53 5.165-1.044 7.491-0.254 11.197-1.37 0.508-0.154 1.112-0.56 1.645-0.286 0.615 0.318 0.585 1.185-0.049 1.464 -3.406 1.502-7.174 0.895-10.955 1.526C103.073 135.502 101.596 135.95 100.083 135.95z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(0.89999969 0 0 0.89999969 7.461054852220798 8.42630728754827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6542",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient6543)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(0.79999927 0 0 0.79999927 14.800197453140711 16.799920175685997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6596",
    d: "M80 84c0 3.313-2.687 5.999-6 5.999S68 87.313 68 84c0-3.316 2.687-6.001 6-6.001S80 80.685 80 84z",
    fill: "#7b5c33",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6597",
    d: "M70.512 86.805c0.875-0.072 0.1-0.306 0.1-0.306 -0.433-0.233-1.248-0.592-1.248-0.921 0-1.031 1.414-1.299-0.034-1.705 -1.504-1.38 1.167-1.352 1.147-1.398 -0.975-2.376 0.299-1.071 0.835-1.773 1.988-2.599 0.554 0.267 1.633 0 0.391-0.096-0.78-1.531 0.034-1.33 0.539 0.132 0.662 0.58 0.662 0.58 0.393-0.077 1.008-0.682 1.008-0.682 0.749 0.226 1.275 1.29 1.043 1.091 0.368-0.045 0.884-0.221 1.286-0.341 0 0 0.07-0.239 0.139-0.033 0.917 2.661 3.284 2.47 0.559 3.24 0 0-0.176 0 0.382 0.442 2.71 2.164-2.102 1.495 0.451 2.49 0.104-0.104-1.53 0.965-1.53 1.261 0 0.501-1.042 1.818-1.946 1.3 -0.504-0.288-0.581 0.6-0.877 0.19 -0.581-0.803-1.742-0.035-1.313-0.773 0.634-0.521-0.654 0.204-0.904 0.204 -0.828 0 1.083-2.783 3.894-0.715 0.822 0.602-0.864-1.433 0.625-1.433 0.149 0.049 0.104-0.521 0.104-0.682 -0.774-0.151 1.39-0.003 1.39-1.262 0.137 0.027 0.509-0.35-1.635 0 0 0-0.068-0.75-0.034-0.886 0.11-0.438 1.214-0.298 0.904-0.75 0-0.001-0.799-1.604-0.799-1.604 -2.573-0.414-1.102-0.672-2.711-0.341 -0.076 0.378-3.445 1.984-3.338 2.729 0.1 0.702 2.115 0.938 0.208 2.182C73.405 91.051 68.437 85.454 70.512 86.805z",
    fill: "#8a6d47",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6598",
    d: "M74 78.749l0.171 4.393 1.837-3.993 -1.523 4.123 3.227-2.985 -2.985 3.226 4.124-1.523 -3.992 1.839 4.392 0.17 -4.392 0.17 3.992 1.839 -4.124-1.523 2.985 3.226 -3.227-2.985 1.523 4.123 -1.837-3.993L74 89.249l-0.171-4.393 -1.838 3.993 1.522-4.123 -3.226 2.985 2.985-3.226 -4.124 1.523 3.992-1.839 -4.39-0.17 4.39-0.17 -3.992-1.839 4.124 1.523 -2.985-3.226 3.226 2.985 -1.522-4.123 1.838 3.993L74 78.749z",
    fill: "#5c3d14",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6599",
    d: "M74.796 80.067l-0.539 3.315 1.981-2.711 -1.766 2.857 2.87-1.748 -2.725 1.964 3.319-0.515L74.668 84l3.266 0.794 -3.317-0.538 2.712 1.982 -2.858-1.765 1.748 2.869 -1.964-2.725 0.516 3.319 -0.771-3.27 -0.795 3.264 0.539-3.315 -1.984 2.711 1.768-2.857 -2.869 1.748 2.725-1.964 -3.319 0.516 3.269-0.771 -3.264-0.793 3.315 0.537 -2.712-1.982 2.858 1.765 -1.747-2.869 1.964 2.725 -0.516-3.318 0.772 3.27L74.796 80.067z",
    fill: "#4d3009",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6600",
    d: "M76.25 84c0 1.243-1.008 2.25-2.25 2.25s-2.25-1.007-2.25-2.25 1.008-2.25 2.25-2.25S76.25 82.757 76.25 84z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6601",
    d: "M71.637 88.311c-0.331 0.332-0.985 0.215-1.46-0.261 -0.476-0.475-0.593-1.129-0.261-1.461 0.331-0.331 0.985-0.214 1.46 0.261C71.852 87.326 71.969 87.979 71.637 88.311z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6602",
    d: "M78.806 82.818c-0.496 0.496-1.697 0.1-2.682-0.886 -0.986-0.986-1.382-2.187-0.886-2.683 0.496-0.496 1.697-0.1 2.682 0.886C78.906 81.122 79.302 82.322 78.806 82.818z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6564",
    d: "M53.294 83c0.809 10.899 11.637 23.583 20.506 22.236 10.498 0.106 20.864-7.868 20.864-22.305s-5.087-26.528-21.127-26.528C62.037 56.402 53.294 68.563 53.294 83zM61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "#93614a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6565",
    d: "M72.262 90.163c3.614 0.398 13.873-1.561 14.253-2.847 0.687-2.32-4.534-6.921-12.052-7.844C68.003 78.68 62.9 79.816 61.907 81.6c0.898-6.4 7.7-11.397 15.987-11.434 8.911-0.037 16.148 5.676 16.172 12.765 0.021 7.088-7.185 12.862-16.095 12.902 -8.913 0.037-16.149-5.676-16.173-12.764 0-0.105 0.016-0.208 0.019-0.313C63.147 88.083 68.651 89.764 72.262 90.163z",
    fill: "url(#SvgjsRadialGradient6566)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6570",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient6571)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6574",
    d: "M62.148 77.417c4.208-1.978 9.35-2.16 13.838-1.005 2.404 0.561 4.965 1.285 7.063 2.638 1.945 1.135 3.525 2.5 5.002 4.19 -1.342-1.701-2.773-3.118-4.623-4.27 -2.276-1.416-4.769-2.294-7.364-2.916C71.478 74.928 66.342 75.184 62.148 77.417z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6575",
    d: "M62.769 78.02c0.88-0.352 4.065-1 5.456-1.066 1.687-0.082 5.073 0.125 6.735 0.424 3.374 0.608 9.251 2.483 11.678 7.184 0.746 1.445 0.074 2.456-0.123 2.675 0.3-2.426-4.838-6.746-12.052-7.604 -7.52-0.894-13.217 0.743-12.711 2.958 1.222 5.348 6.846 7.013 10.51 7.405 4.099 0.439 11.684-1.539 12.686-1.753 -1.999 1.009-7.524 2.095-9.767 2.303 -0.744 0.07-2.24 0.104-2.986 0.085 -5.949-0.158-10.169-3.175-11.729-7.26C59.464 80.745 60.56 78.902 62.769 78.02z",
    fill: "#131111",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(0.89999969 0 0 0.89999969 12.487242308353615 8.426286115912816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6549",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient6550)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "translate(-0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(0.79999927 0 0 0.79999927 25.20010571296028 16.799920175685997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6603",
    d: "M132,83.999c0,3.316-2.684,6-6,6s-6-2.684-6-6s2.684-6,6-6S132,80.683,132,83.999z",
    fill: "#7b5c33",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6604",
    d: "M122.508 86.806c0.879-0.076 0.105-0.305 0.105-0.305 -0.434-0.234-1.254-0.592-1.254-0.926 0-1.031 1.418-1.295-0.023-1.705 -1.512-1.377 1.16-1.348 1.137-1.395 -0.973-2.379 0.305-1.072 0.844-1.775 1.98-2.596 0.551 0.27 1.629 0 0.387-0.094-0.785-1.529 0.035-1.33 0.539 0.135 0.656 0.58 0.656 0.58 0.398-0.076 1.008-0.68 1.008-0.68 0.75 0.223 1.277 1.289 1.043 1.09 0.375-0.047 0.891-0.223 1.289-0.34 0 0 0.07-0.24 0.141-0.035 0.914 2.66 3.281 2.473 0.563 3.24 0 0-0.176 0 0.375 0.439 2.707 2.168-2.098 1.494 0.457 2.49 0.105-0.1-1.535 0.967-1.535 1.266 0 0.498-1.043 1.816-1.945 1.295 -0.504-0.287-0.586 0.604-0.879 0.193 -0.574-0.803-1.746-0.035-1.313-0.773 0.633-0.521-0.656 0.205-0.902 0.205 -0.832 0 1.078-2.783 3.891-0.715 0.82 0.598-0.867-1.436 0.633-1.436 0.141 0.047 0.105-0.521 0.105-0.68 -0.785-0.152 1.383-0.006 1.383-1.266 0.141 0.029 0.516-0.346-1.629 0 0 0-0.07-0.75-0.035-0.885 0.105-0.439 1.207-0.299 0.902-0.75l-0.797-1.605c-2.578-0.41-1.102-0.668-2.719-0.34 -0.07 0.381-3.445 1.986-3.34 2.73 0.105 0.703 2.121 0.938 0.211 2.18C125.402 91.054 120.434 85.452 122.508 86.806z",
    fill: "#8a6d47",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6605",
    d: "M126 78.749l0.176 4.395 1.828-3.996 -1.523 4.125 3.234-2.988 -2.988 3.229 4.125-1.523 -3.996 1.84 4.395 0.17 -4.395 0.17 3.996 1.84 -4.125-1.523 2.988 3.229 -3.234-2.988 1.523 4.125 -1.828-3.996L126 89.249l-0.176-4.395 -1.84 3.996 1.523-4.125 -3.223 2.988 2.988-3.229 -4.125 1.523 3.996-1.84 -4.395-0.17 4.395-0.17 -3.996-1.84 4.125 1.523 -2.988-3.229 3.223 2.988 -1.523-4.125 1.84 3.996L126 78.749z",
    fill: "#5c3d14",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6606",
    d: "M126.797 80.067l-0.539 3.316 1.98-2.713 -1.77 2.859 2.871-1.752 -2.719 1.969 3.316-0.516 -3.27 0.768 3.27 0.797 -3.316-0.539 2.707 1.98 -2.859-1.764 1.746 2.871 -1.957-2.725 0.516 3.316L126 84.667l-0.797 3.264 0.539-3.316 -1.98 2.713 1.77-2.859 -2.871 1.752 2.719-1.969 -3.316 0.516 3.27-0.768 -3.27-0.797 3.316 0.539 -2.707-1.98 2.859 1.764 -1.746-2.871 1.957 2.725 -0.516-3.316 0.773 3.27L126.797 80.067z",
    fill: "#4d3009",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6607",
    d: "M128.25 83.999c0 1.242-1.008 2.25-2.25 2.25s-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25S128.25 82.757 128.25 83.999z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6608",
    d: "M123.633 88.312c-0.328 0.328-0.984 0.217-1.453-0.264 -0.48-0.475-0.598-1.125-0.258-1.459 0.328-0.328 0.984-0.211 1.453 0.264C123.855 87.327 123.973 87.978 123.633 88.312z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6609",
    d: "M130.805 82.815c-0.492 0.498-1.699 0.105-2.684-0.885 -0.984-0.984-1.383-2.186-0.879-2.678 0.492-0.498 1.688-0.105 2.672 0.885C130.91 81.122 131.297 82.323 130.805 82.815z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6584",
    d: "M126.063 56.402c-16.04 0-21.127 12.091-21.127 26.528s10.366 22.412 20.864 22.305c8.869 1.347 19.697-11.337 20.506-22.236C146.307 68.563 137.563 56.402 126.063 56.402zM127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 7.52-0.922 13.217 0.767 12.711 3.051C136.627 88.04 131.003 89.758 127.339 90.163z",
    fill: "#93614a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6585",
    d: "M127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 6.46-0.792 11.563 0.345 12.556 2.128 -0.898-6.4-7.7-11.397-15.987-11.434 -8.911-0.037-16.148 5.676-16.172 12.765 -0.021 7.088 7.185 12.862 16.095 12.902 8.913 0.037 16.149-5.676 16.173-12.764 0-0.105-0.016-0.208-0.019-0.313C136.453 88.083 130.949 89.764 127.339 90.163z",
    fill: "url(#SvgjsRadialGradient6586)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6590",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient6591)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6594",
    d: "M137.452 77.417c-4.208-1.978-9.35-2.16-13.838-1.005 -2.404 0.561-4.965 1.285-7.063 2.638 -1.945 1.135-3.525 2.5-5.002 4.19 1.342-1.701 2.773-3.118 4.623-4.27 2.276-1.416 4.769-2.294 7.364-2.916C128.123 74.928 133.259 75.184 137.452 77.417z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6595",
    d: "M136.832 78.02c-0.88-0.352-4.065-1-5.456-1.066 -1.687-0.082-5.073 0.125-6.735 0.424 -3.374 0.608-9.251 2.483-11.678 7.184 -0.746 1.445-0.074 2.456 0.123 2.675 -0.3-2.426 4.838-6.746 12.052-7.604 7.52-0.894 13.217 0.743 12.711 2.958 -1.222 5.348-6.846 7.013-10.51 7.405 -4.099 0.439-11.684-1.539-12.686-1.753 1.999 1.009 7.524 2.095 9.767 2.303 0.744 0.07 2.24 0.104 2.986 0.085 5.949-0.158 10.169-3.175 11.729-7.26C140.137 80.745 139.041 78.902 136.832 78.02z",
    fill: "#131111",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2885",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2886)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2889",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2890)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(0.89999969 0 0 0.89999969 7.266745225978553 7.074807545849076) rotate(7.500000200000001 72.66722689138183 73.74785654013672) translate(1.0000001 3.0000004000000002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6526",
    d: "M74.799 71.28c-4.425-0.475-21.252 3.714-21.252 3.714s16.789-6.74 23.757-5.667c5.188 0.798 14.397 5.077 12.706 7.339C88.649 78.487 84.408 72.312 74.799 71.28z",
    fill: "#080806",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(0.89999969 0 0 0.89999969 12.733279199136902 7.074807545849076) rotate(-7.5 127.3323973609375 73.74785654013672) translate(-1.0000001 3.0000004000000002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6527",
    d: "M109.731 76.398c-1.713-2.292 7.592-6.31 13.546-6.804 7.117-0.59 22.914 4.085 22.914 4.085s-15.9-2.628-20.377-2.106C115.998 72.718 111.11 78.243 109.731 76.398z",
    fill: "#080806",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5022",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#844e35",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5023",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#652e15",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5024",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#b28e7d",
    strokeWidth: "none",
    opacity: 0.2,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6211",
    d: "M120.87 131.85c-0.01-2.22-0.6-4.27-2.97-5.26 -3.38-1.41-7.77-2.78-11.12-4.25 -1.82-0.8-3.46-0.9-4.41 1.07 -1.12 2.34 0.71 2.9 2.42 3.51 13.48 4.78 13.84 2.15 13.48 19.3 -0.08 3.68-1.87 5.58-4.38 6.91 -2.62 1.38-4.31-1.11-5.94-2.77 -2.27-2.3-4.47-4.67-7.95-8.34v0c0 0 0 0 0 0 0 0 0 0 0 0v0c-3.48 3.67-5.68 6.04-7.95 8.34 -1.63 1.66-3.31 4.15-5.94 2.77 -2.51-1.32-4.31-3.23-4.38-6.91 -0.36-17.15 0-14.52 13.48-19.3 1.71-0.61 3.54-1.18 2.42-3.51 -0.95-1.97-2.59-1.87-4.41-1.07 -3.35 1.47-7.74 2.84-11.12 4.25 -2.37 0.99-2.96 3.04-2.97 5.26 -0.02 7.07-0.24 14.15 0.19 21.2 0.38 6.18 14.6 17.58 20.68 16.79 6.08 0.79 20.3-10.62 20.68-16.79C121.11 146 120.89 138.92 120.87 131.85z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6212",
    d: "M103 167c0-2 0.16-2.67 1-5 -2.06 2.82-2.1 3.8-3.6 5.2 0-1-0.4-3.2-0.4-4.2 -0.74 0.74-1.02 3.64-1.45 4.29C98.34 166.17 96 164.62 96 163c-1 2 1 3 1 5 -7.12-4.45-14.15-8.38-17.75-16.01 0.04 1.05 0 0 0.06 1.05 0.38 6.18 14.6 17.58 20.68 16.79 6.08 0.79 20.3-10.62 20.68-16.79 0.11-1.86 0.08 0 0.11-1.86C118.12 159.93 111.31 163.68 103 167z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6204",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#cac1b2",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6190",
    d: "M150.81 99.442c-0.208 0-0.427-0.01-0.651-0.029 -1.972-6.396 0.331-15.486 4.25-20.951 -2.674-7.41 2.494-3.557 1.635-12.393 -0.155-1.27 0.052-2.412 0.479-3.584 -1.269-3.313-1.619-7.189-1.198-9.319 -3.629-9.571-4.898-3.055-6.83-14.894 -2.96-1.071-8.371-5.169-10.667-6.959 -5.957-4.648-14.879 9.828-22.333 4.959 -4.442 4.032-12.805 3.311-15.521 2.409 -3.829 1.928-11.513 0.935-15.506-2.411 -6.414 4.608-9.373-6.881-20.2-6.579 -6.807 4.91-4.954 5.704-12.766 8.582 -0.698 4.549-0.054 5.279-3.703 9.208 -2.154 2.286-2.162 3.08-3.032 5.394l-0.156 0 0.053 0.271 -0.038 0.099 0.071 0.074c0.474 2.586-0.39 6.584-1.227 9.184 1.617 4.484-1.381 5.75 1.942 10.274 1.073 1.461 1.47 2.024 0.169 5.686 4.717 6.58 6.05 16.876 4.265 20.953 -7.124 0.687-6.721-9.202-7.304-12.656 -1.365-9.695-11.698-2.623-9.94-11.778 -2.641-2.091-1.968-4.754-1.073-8.9 -2.452-5.161-7.248-23.656 0.681-28.05 -0.558-6.983 2.841-13.939 8.591-16.91 0.856-6.626 9.141-16.875 15.649-15.523 1.494-7.913 15.707-17.864 21.96-13.427 4.878-4.65 15.003-6.226 21.571-4.299 7.221-1.883 16.184-0.474 21.605 4.291 6.435-4.408 20.349 5.649 21.952 13.405 7.113-0.673 14.411 8.336 15.669 15.567 5.934 3.057 9.076 10.023 8.574 16.897 7.476 4.135 3.791 20.938 0.694 28.041 0.689 3.6 1.757 6.655-1.079 8.909 1.897 9.601-8.953 0.934-10.171 13.722C156.838 92.721 156.198 99.442 150.81 99.442L150.81 99.442z",
    fill: "#080806",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6191",
    d: "M160.293 77.838c-0.832 0.07-1.664-1.301-2.496-1.301 0-5.101 3.042-8.163 6.084-11.223 -1.014 0-2.027-2.041-3.042-1.021 -3.042-5.102 2.028-10.203 4.057-14.285 -6.085 1.021-11.154-6.121-7.099-11.223 0.704 0 1.408-0.982 2.112-1.242 -3.592-0.822-6.327-1.118-8.196-4.88 -1.014-3.061 0-6.122 2.028-9.182 -6.084 4.082-14.196 2.041-18.251-4.081 0-1.021 0-3.062 0-4.082 -2.029 5.102-7.099 9.182-13.183 7.142 -1.646 0-4.63-1.345-5.694-4.037 0.181 2.555-0.609 5.058-1.404 5.058 -6.084 3.06-14.195-1.021-15.209-8.163 0 4.082-2.028 9.182-4.056 10.203 -5.07 3.061-11.154-3.062-9.126-10.203 -2.028 7.142-8.112 10.203-14.196 8.163 -3.042-1.021-7.098-3.061-7.098-8.163 -3.042 7.142-11.154 14.284-16.224 5.102 3.042 8.162-2.577 17.345-8.244 17.345 4.015 5.491 1.147 17.345-5.951 17.345 8.111 2.041 4.056 11.223 5.069 17.345 -0.905 0-1.811 1.623-2.717 1.243 8.477 5.359 10.408 15.83 12.063 25.733 0.107-0.005 0.211-0.006 0.323-0.016 1.785-4.077 0.452-14.374-4.265-20.953 1.301-3.662 0.904-4.225-0.169-5.686 -3.323-4.524-0.325-5.79-1.942-10.274 0.837-2.599 1.701-6.598 1.227-9.184l-0.071-0.074 0.038-0.099 -0.053-0.271 0.156 0c0.87-2.314 0.878-3.108 3.032-5.394 3.649-3.93 3.005-4.66 3.703-9.208 7.813-2.878 5.959-3.672 12.766-8.582 10.827-0.302 13.786 11.187 20.2 6.579 3.993 3.346 11.677 4.338 15.506 2.411 2.717 0.902 11.079 1.623 15.521-2.409 7.454 4.869 16.376-9.607 22.333-4.959 2.296 1.79 7.707 5.888 10.667 6.959 1.932 11.839 3.201 5.323 6.83 14.894 -0.421 2.13-0.07 6.007 1.198 9.319 -0.427 1.172-0.634 2.314-0.479 3.584 0.859 8.836-4.309 4.983-1.635 12.393 -3.695 5.154-5.95 13.526-4.543 19.829C148.86 90.198 152.749 81.539 160.293 77.838z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6192",
    d: "M132.061 10.84c1.719-1.024 8.918-0.546 10.395-5.612C142.833 11.226 136.312 11.595 132.061 10.84zM148.412 10.075c2.97 0.951 4.813 6.225 5.07 7.524C154.263 14.153 152.04 9.675 148.412 10.075zM149.553 16.707c1.437 1.297 0.971 5.101 0.507 6.122C151.689 21.296 151.909 17.608 149.553 16.707zM147.398 17.982c0.111 2.74-0.195 4.648-1.648 6.632C148.398 23.297 148.441 20.748 147.398 17.982zM155.383 23.339c0.788-0.513 5.585-0.415 6.084 0.766C161.489 21.83 156.615 21.84 155.383 23.339zM153.482 28.058c4.019-0.083 3.455-1.2 7.604-0.893C158.206 25.239 155.729 27.129 153.482 28.058zM158.806 29.716c-0.858 1.02-2.829 1.62-2.915 4.208C157.111 31.625 157.822 31.719 158.806 29.716zM162.861 36.093c3.256 1.638 4.257 3.755 5.07 7.27C168.833 39.356 167.064 36.289 162.861 36.093zM164.129 40.684c1.822 1.815 1.932 5.626 0.887 8.035C167.424 46.734 167.503 42.097 164.129 40.684zM162.607 43.618c-0.374 1.859-1.179 2.688-2.154 4.846C162.014 47.274 162.925 45.685 162.607 43.618zM163.621 55.606 163.621 55.606c1.053 3.215 1.918 4.353 0.635 6.505C166.854 60.487 165.595 57.942 163.621 55.606zM162.101 56.755c-0.05 1.904-0.276 3.379-1.394 5.739C162.271 61.371 163.026 59.411 162.101 56.755zM127.752 13.263c0.51 2.492 4.538 3.179 4.538 3.179 1.04 0.244 2.542 0.184 3.447-0.5C134.647 16.127 128.78 14.629 127.752 13.263zM122.809 8.8c1.536-2.926 4.926-4.827 8.111-5.357C126.71 2.296 123.261 4.881 122.809 8.8zM120.4-3.827c1.942 1.783 1.96 4.773 2.027 8.672C123.975 1.994 123.902-2.445 120.4-3.827zM121.414-5.485c1.539 0.299 3.979 4.701 4.184 5.74C126.17-2.325 123.604-5.916 121.414-5.485zM118.879-1.786c0.318 3.139 0.03 5.48-1.646 8.162C120.269 4.559 120.521 1.362 118.879-1.786zM115.711 7.652c-5.082 0.921-7.161 7.895-5.45 12.499C110.482 18.128 112.168 10.188 115.711 7.652zM110.641 3.825c-9.45 3.409-8.715 14.028-5.07 16.453C104.695 18.888 103.081 10.255 110.641 3.825zM99.614 4.081c-5.041 7.576 0.793 12.744 2.918 16.666C101.128 15.722 97.8 10.264 99.614 4.081zM107.473-2.806c-1.478 0.201-5.937-0.941-6.338 2.55C102.744-2.686 105.359-1.298 107.473-2.806zM110.768-4.464c-4.262-4.366-5.752-2.456-6.465-1.914C106.896-7.17 108.012-5.867 110.768-4.464zM108.613-9.821c3.063 0.032 5.401 2.261 6.211 5.229C115.605-8.087 112.316-11.478 108.613-9.821zM78.193-0.639c3.703-3.293 7.981-6.629 12.421-5.102C86.39-9.9 80.756-5.989 78.193-0.639zM83.137-0.128c-7.265 6.348-1.188 12.163 1.141 11.861C83.263 11.249 79.169 7.446 83.137-0.128zM85.291 4.335c1.063 0.854 1.756 1.699 2.028 4.846C88.166 7.073 87.671 5.06 85.291 4.335zM92.896-0.639c0.103 0.381 1.558 5.335 1.167 5.335 -0.128 1.343-0.398 1.915-1.04 3.083C97.603 5.28 93.521 0.39 92.896-0.639zM92.263-3.699c4.813-0.473 4.962 5.761 4.689 7.524C99.773-0.397 96.927-6.515 92.263-3.699zM80.221 13.901c2.226 0.595 0.982 3.246 1.268 7.015C82.734 18.018 83.297 13.608 80.221 13.901zM75.166 9.612c-2.058-8.338-8.633-6.934-8.633-6.934 1.32-0.367 6.271 3.712 7.03 9.422 0.219 1.134 0.444 3.079 0.701 4.607C74.584 15.687 75.839 11.99 75.166 9.612zM68.307 8.162c2.32 1.8 0.981 7.046 0 9.821C71.302 15.007 72.167 9.307 68.307 8.162zM64.505 9.437c1.449 1.902-1.703 5.647-3.676 8.163C64.029 16.283 67.604 11.589 64.505 9.437zM69.194-6.25c-2.841-0.465-5.571 3.311-4.816 6.122C64.731-1.832 67.176-5.672 69.194-6.25zM67.8-2.551c-2.279 0.454-2.191 3.93-1.141 5.356C66.538 1.785 66.504-2.082 67.8-2.551zM53.351 11.478c-4.011-1.786-7.875-0.083-8.492 3.955C46.927 12.637 49.917 11.543 53.351 11.478zM51.069 15.049c-2.755-1.719-6.26 1.727-5.577 4.847C45.919 17.705 48.8 14.798 51.069 15.049zM49.422 18.365c-3.4 0.307-3.967 5.263-1.901 6.887C46.738 23.542 47.416 19.313 49.422 18.365zM40.93 23.722c2.196 1.012 4.552 2.976 4.277 2.976 0.792 1.14 0.959 1.559 1.299 2.891C47.386 25.745 44.818 24.23 40.93 23.722zM42.704 28.186c1.926 1.488 3.417 4.226 2.155 7.015C47.482 33.076 46.363 29.374 42.704 28.186zM40.485 29.368c-0.172-0.171-0.323-0.155-0.317-0.162 0.555 0.076 0.272 3.473-1.024 4.476 -0.413 0.455-1.79 1.805-2.271 2.284C42.358 34.09 41.5 30.358 40.485 29.368zM38.268 38.771c1.558 1.928 1.78 4.979 1.446 5.314 -0.309 2.233-0.127 1.246-0.558 3.614C41.32 45.208 42.168 41.147 38.268 38.771zM36.367 42.47c1.185 0.987 0.939 5.241-0.761 6.122C38.497 48.388 38.726 43.236 36.367 42.47zM32.691 42.98c1.353 1.627 0.405 2.484-3.802 7.27C33.319 48.206 35.744 44.46 32.691 42.98zM32.691 55.097c2.448 1.836 0.636 6.208-0.381 7.269C35.531 60.846 36.123 55.928 32.691 55.097zM36.747 59.178c1.534 0.44-0.776 4.06-1.648 5.101C37.811 62.885 39.197 59.095 36.747 59.178zM79.428 17.256c0.258 2.781-2.367 5.437-2.882 5.956C80.154 22.118 80.116 18.763 79.428 17.256zM120.893 18.134c0 0-1.006-1.314-1.76-2.405 0.485 2.857 2.174 5.255 5.07 5.782C123.805 21.214 120.893 18.54 120.893 18.134zM121.837 15.049c0.377 2.068 1.907 3.618 4.057 3.742C124.583 18.038 123.274 16.978 121.837 15.049zM166.453 68.786c-0.839 1.81-2.587 2.872-3.719 4.761C166.084 71.548 166.283 70.411 166.453 68.786zM165.438 73.887c-1.014 0.524-2.677 1.033-4.395 3.062C163.563 76.018 164.425 74.814 165.438 73.887zM32.944 68.105c0.782 1.301 1.849 2.354 3.042 3.062C35.235 69.891 34.186 68.863 32.944 68.105zM33.283 71.846c1.256 4.162 3.379 3.742 3.379 3.742C35.529 74.953 33.666 72.606 33.283 71.846z",
    fill: "#171714",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6193",
    d: "M168.08 37.856c0.439-6.042-2.227-13.634-8.619-16.927 -1.242-7.001-8.668-16.365-15.699-15.692 -1.551-7.575-15.768-17.858-22.165-13.458 -4.675-4.112-13.479-6.324-21.624-4.224 -6.935-2.012-17.092-0.073-21.603 4.224 -6.164-4.382-20.718 5.766-22.167 13.458 -6.271-1.292-14.833 9.064-15.688 15.683 -5.429 2.796-9.194 9.783-8.627 16.937 -8.059 4.451-2.987 23.388-0.684 28.263 -0.237 1.117-0.891 3.905-0.762 5.112 0.011 0.459 0.029 0.765 0.039 0.765 0.294 1.02 0.365 1.988 1.783 3.111 -1.767 9.213 8.648 2.297 9.976 11.704 0.668 3.964 0.144 8.049 2.901 11.152 1.391 1.519 3.904 1.903 4.894 1.734 1.933-4.083 0.56-14.696-4.132-21.285 1.653-4.674 0.4-4.524-1.217-7.224 -1.506-2.513 0.361-5.153-0.911-8.692 1.407-4.349 1.496-7.771 1.189-9.316 0.01 0 0.01 0 0-0.01 0.94-2.462 0.88-3.187 3.04-5.479 3.719-4.005 3.097-4.882 3.755-9.192 7.218-1.782 5.407-3.808 12.522-7.778 5.82-3.248 13.681 10.589 20.163 5.931 1.431 1.197 2.509 1.708 4.121 2.347 0.724 0.221 0.59 0.26 1.822 0.469 0.268 0.031 6.23 0.379 6.23 0.102 0.588-0.06 2.819-0.285 3.368-0.561 0.933 0.311 2.433 0.465 3.369 0.561 0 0.01 1.622 0.112 3.229 0.112 3.639 0.142 6.949-1.239 8.932-3.03 7.635 4.975 16.719-9.591 23.073-4.03 5.963 5.219 7.936 5.26 9.635 5.877 0.054 0.33 0.259 2.477 0.386 3.296 1.094 5.448 3.712 4.289 6.398 11.396 -0.203 1.022-0.461 4.964 1.189 9.296 -0.367 1.02-0.627 2.225-0.458 3.611 0.842 8.636-4.333 4.96-1.673 12.314 -3.565 4.975-6.371 14.319-4.149 21.243 0.01 0.011 0.01 0.031 0.018 0.042 7.612 0.869 7.239-9.595 7.795-12.887 1.317-9.33 11.76-2.561 9.985-11.704 1.439-1.147 1.508-2.091 1.772-3.111 0.011 0 0.032-0.306 0.042-0.755 0.135-1.285-0.561-4.111-0.755-5.132C169.89 63.544 176.97 42.763 168.08 37.856zM168.662 64.64c-0.066 0.372-0.266 1.149-0.483 1.745 0.075 0.439 1.065 5.52 0.634 5.52 -0.313 1.021-0.106 1.572-1.517 2.918 1.396 8.56-9.47 1.01-11.043 11.715 -0.932 5.7 0.069 11.547-5.895 12.517 -1.192-5.739 1.433-15.507 4.29-20.477 -2.27-6.842 2.923-3.58 2.049-12.57 -0.159-1.346-0.021-2.284 0.269-3.306 -0.739-2.165-1.521-6.084-1.238-8.764 -2.384-8.027-0.61-3.267-4.884-9.112 -0.018-0.031-0.449-0.785-0.465-0.816l-0.01-0.011c-1.057-2.263-0.765-3.4-1.357-5.897 -0.002 0-5.551-2.566-10.486-6.758 -6.139-5.211-15.494 8.794-23.229 4.809 -3.995 3.086-11.915 2.875-15.313 2 -1.901 0.436-7.221 0.795-10.4 0.143 -0.081-0.017-1.438-0.418-1.506-0.439 -1.102-0.336-2.462-1.079-3.427-1.704 -6.963 4.059-14.429-11.927-21.948-5.806 -4.398 3.581-6.598 6.223-11.739 7.755 -0.396 1.02-0.226 3.548-1.367 5.897v0.011c0 0-0.219 0.767-2.307 2.969 -2.607 2.836-2.287 4.612-3.051 6.968 0.282 2.692-0.469 6.161-1.229 8.765 1.031 3.708-1.207 6.535 1.436 9.886 2.151 2.793 1.439 3.041 0.883 5.989 2.547 4.477 5.584 14.194 4.279 20.478 -10.286-1.63-0.016-17.209-12.887-19.346 -1.931-0.3-3.292-0.333-3.823-1.836 -0.31-0.895-0.318-2.528-0.229-3.062 -1.387-1.429-1.216-1.897-1.504-2.918 -0.504 0 0.623-5.02 0.623-5.509 -0.374-1.021-7.082-23.671 0.742-28.518 0-7.009 3.865-13.862 8.411-16.672 0.049-0.204 0.107-0.408 0.168-0.623 0-0.01 0.009-0.02 0.009-0.03 1.941-6.005 9.653-15.581 15.699-14.774 1.413-6.243 15.997-17.535 21.86-13.54 6.708-4.132 14.734-5.069 21.296-3.713 8.431-1.547 16.608 0.454 21.314 3.713 5.643-3.844 19.766 6.539 21.861 13.54 6.383-0.851 14.061 9.505 15.708 14.794v0.01c0.06 0.215 0.121 0.419 0.179 0.623 5.865 4.039 7.521 9 8.379 16.295 0 0.117 0.021 0.191 0.021 0.367C174.08 42.33 170.504 55.007 168.662 64.64z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4193",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#268135",
    strokeWidth: "none",
    opacity: 1
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1036",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1037",
    fontFamily: "\"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400,
      display: "none"
    },
    fontSize: "0.84em",
    textAnchor: "middle",
    fontWeight: 400,
    fill: "#000000",
    x: 100,
    y: 185
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1038",
    dy: "1.2em",
    x: 100,
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400
    }
  }, "Created on AvatarMaker.com"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1001"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2886",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2887",
    stopOpacity: 0.5,
    stopColor: "#a27662",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2888",
    stopOpacity: 0,
    stopColor: "#93614a",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2890",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2891",
    stopOpacity: 0.5,
    stopColor: "#a27662",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2892",
    stopOpacity: 0,
    stopColor: "#93614a",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5790",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5791",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5792",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5796",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5797",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5798",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5800",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5801",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5802",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5804",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5805",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5806",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5813",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5814",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5815",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5819",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5820",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5821",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5823",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5824",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5825",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5827",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5828",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5829",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5846",
    x1: 127.637,
    y1: 79.822,
    x2: 125.91,
    y2: 81.88,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5847",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5848",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5851",
    x1: 129.637,
    y1: 79.823,
    x2: 127.91,
    y2: 81.881,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5852",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5853",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient6370",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6371",
    stopOpacity: 1,
    stopColor: "#8b573f",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6372",
    stopOpacity: 1,
    stopColor: "#844e35",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient6469",
    x1: 100,
    y1: 172,
    x2: 100,
    y2: 128.5,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6470",
    stopOpacity: 0.8,
    stopColor: "#844e35",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6471",
    stopOpacity: 1,
    stopColor: "#652e15",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6543",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6544",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6545",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.315
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6546",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6547",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6548",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6550",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6551",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6552",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6553",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6554",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6555",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6557",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6558",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6559",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6560",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6561",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6562",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6566",
    cx: 121.986,
    cy: 82.496,
    fx: 133.239,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(0.9998 0.0208 0.0166 -0.7998 -45.3195 145.9395)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6567",
    stopOpacity: 1,
    stopColor: "#844e35",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6568",
    stopOpacity: 0.3,
    stopColor: "#844e35",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6569",
    stopOpacity: 0,
    stopColor: "#93614a",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6571",
    cx: 68.931,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6572",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6573",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6577",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6578",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6579",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6580",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6581",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6582",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6586",
    cx: 121.587,
    cy: 82.496,
    fx: 132.839,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(-0.9998 0.0208 -0.0166 -0.7998 244.5208 145.9478)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6587",
    stopOpacity: 1,
    stopColor: "#844e35",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6588",
    stopOpacity: 0.3,
    stopColor: "#844e35",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6589",
    stopOpacity: 0,
    stopColor: "#93614a",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6591",
    cx: 69.316,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6592",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6593",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliot);
export default __webpack_public_path__ + "static/media/eliot.d7038eac2063a7e5516f00c6f21bca72.svg";
export { ForwardRef as ReactComponent };